import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import Modal from "../../../components/Modal";
import { formatDate, formatDateDDMMYYYY, formatToZMW, handlePrint, rootUrl, sumOfArray } from "../../../helpers";
import { useAuth } from "../../../context/auth-context";
import AddBillModal from "./addBill";
import { useOutletContext } from 'react-router-dom';
import DataTable from "react-data-table-component";
import { FaArrowAltCircleDown, FaArrowAltCircleLeft, FaEye, FaFile, FaFilePdf, FaHome, FaList, FaPlus, FaPrint, FaSpinner, FaToggleOn, FaSearch, FaFilter, FaTimes, FaMoneyBill, FaLink } from "react-icons/fa";
import { collapse } from "@material-tailwind/react";
import FormGenerator from "../../../components/formGenerator";
import { toast } from "react-toastify";
import { FaFileLines } from "react-icons/fa6";
import { PiInvoice } from "react-icons/pi";
import { customStyles } from "../../../styles";
import PayForm from "./form";
import ActualBills from "./actualBills";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

const Bills = () => {
  const [bills, setBills] = useState([]);
  const [searchQuery, setSearchQuery] = useState(''); 
  const [recs, setRecs] = useState([]);
  const [toggle, setToggle] = useState(false);
  const [showBillModal, setShowBillModal] = useState(false);
  const [showAddBillModal, setShowAddBillModal] = useState(false);
  const [selectedBill, setSelectedBill] = useState([]);
  const [actualBill, setActualBill] = useState([]);
  const [property, setProperty] = useState([]);
  const [statement, setStatement] = useState([]);
  const [makePayment, setMakePayment] = useState(false);
  const [linkProperty, setLinkProperty] = useState(false);
  const [showDemandNotice, setShowDemandNotice] = useState(false);
  const [availableProperties, setAvailableProperties] = useState([]);
  const [activeTab, setActiveTab] = useState('customers'); // Add state for tab selection

  const auth = useAuth();
  // const { dept, coa ,program ,subProgram, bank, cc, sof  } = useOutletContext();
  const {allData, setAllData} = useOutletContext();

  // Fetch Bill
  useEffect(() => {
    fetchBills();
  }, []);

  const fetchBills = async () => {
    try {
      const response = await axios.get(rootUrl(`/bills/${auth.user.id}`));
      if(response.data.status === 200){
        setBills(response.data.data);
      }else{
        toast.error("Error fetching bills")
      }
    
    } catch (error) {
      console.error("Error fetching bills:", error);
    }
  };



  const filteredData = bills?.length > 0? bills.filter(customer =>
    customer.name?.toLowerCase().includes(searchQuery?.toLowerCase()) 
  ):[]

  const handleViewBill = async (customer, openDemandNotice = false) => {
    try {
      const response = await axios.get(rootUrl(`/bill/${customer}`));
      setSelectedBill(response.data.bills);
      setRecs(response.data.recs);
      setProperty(response.data.property)
      setShowBillModal(true);
      setShowDemandNotice(openDemandNotice);
      setToggle(false);

      const billz = response.data.bills.map((bill) => ({
        ...bill,
        type: "Bill",
        date: new Date(bill.date),
      }));
  
      const receipts = response.data.recs.map((rec) => {
        const matchingBill = response.data.bills.find(b => b.item_id == rec.b_id);
        return {
          ...rec,
          type: "Receipt",
          date: new Date(rec.date),
          pid: matchingBill?.pid,
        };
      });
  
      // Merge and sort by date
      const combined = [...billz, ...receipts].sort((a, b) => a.date - b.date);
      setStatement(combined);

    } catch (error) {
      console.error("Error fetching bill details:", error);
    }
  };

  const handleAddBill = () => {
    setShowAddBillModal(true);
  };

  const totalOutstanding = bills.reduce((sum, row) => sum + parseFloat(row.amount), 0);

  const columns = [
    {
        name: "Sn",
        selector: (row, index) => index + 1,
        sortable: true,
        width: "50px",
    },
    {
        name: "Customer",
        selector: (row) => `${row.name}`,
        sortable: true,
    },
    {
        name: "Outstanding",
        selector: (row) => formatToZMW(row.amount),
        sortable: true,
    },
    {
        name: "Actions",
        cell: (row) => (
            <div className="flex gap-2">
                <button
                    onClick={() => handleViewBill(row.customer)}
                    className="p-2 bg-blue-100 hover:bg-blue-200 text-blue-700 rounded-lg transition-colors"
                    title="View Bill"
                >
                    <FaEye className="text-sm" />
                </button>
                {row.has_property == 1 && (
                    <button
                        onClick={() => handleViewBill(row.customer, true)}
                        className="p-2 bg-amber-100 hover:bg-amber-200 text-amber-800 rounded-lg transition-colors"
                        title="Demand Notice"
                    >
                        <FaFileLines className="text-sm" />
                    </button>
                )}
            </div>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
    },
];

const [isDebit, setIsDebit] = useState(true)

const [items, setItems] = useState([])
const [itemGroup, setItemGroup] = useState([])
const showActBill = (obj, isDeb) =>{
  setToggle(true)
  setIsDebit(isDeb)
  const matchKey = isDeb ? obj.invoice_no : obj.receipt_no
  const grouped = statement.filter(entry => {
    if (isDeb) {
      if (!matchKey) {
        return entry.type === "Bill" && entry.b_id === obj.b_id
      }
      return entry.type === "Bill" && entry.invoice_no === matchKey
    }
    if (!matchKey) {
      return entry.type === "Receipt" && entry.id === obj.id
    }
    return entry.type === "Receipt" && entry.receipt_no === matchKey
  })
  const normalizedGroup = grouped.length > 0 ? grouped : [obj]
  setItemGroup(normalizedGroup)
  setItems(normalizedGroup[0] || obj)

}

const fields = [
  {type: 'select', name: 'billID', label: 'Bill', required: true, options:
    selectedBill?.map((res)=>({
      value:res.b_id,
      label:`${allData.budget?.find(a=>a.id === res.coa_id)?.coa}`
    }))
  },
  {type: 'select', name: 'type', label: 'Type', required: true, options:[
    {value:1, label:'Payment'},
    {value:2, label:'Credit note'},
  ]},
  {type: 'text', name: 'amount', label: 'Amount', required: true},
  {type: 'text', name: 'description', label: 'Description', required: true},
]

const onSubmitForm = async (formdata)=>{

  formdata['uid'] = auth.user.id
  formdata['billID'] = selectedBill[0]?.b_id
  
  try{

    const response = await axios.post(rootUrl('/addPayment'), formdata)

    if(response.data.status === 200){
      toast.success("Submitted successfully")
      setMakePayment(false)
      handleViewBill(selectedBill[0].customer)
    }else{
      toast.error("Something went wrong")
    }


  }catch(e){
    toast.error(e?.message)
  }

}

const fetchProperties = async () => {
  try {
    const response = await axios.get(rootUrl(`/getProperties/${auth.user.id}`));
    if(response.data.status === 200){
      setAvailableProperties(response.data.data || []);
    }
  } catch (error) {
    console.error("Error fetching properties:", error);
    toast.error("Error fetching properties");
  }
};

const handleLinkProperty = async (propertyId) => {
  if (!propertyId) {
    toast.error("Please select a property");
    return;
  }

  // Get bill ID from the current item being viewed
  const billId = items?.b_id || (itemGroup && itemGroup.length > 0 ? itemGroup[0]?.b_id : null);
  if (!billId) {
    toast.error("Bill ID not found. Please ensure you are viewing a bill.");
    return;
  }

  try {
    const response = await axios.post(rootUrl('/linkBillToProperty'), {
      billID: billId,
      propertyID: propertyId
    });

    if(response.data.status === 200){
      toast.success("Property linked successfully");
      setLinkProperty(false);
      // Refresh the bill view to show updated data
      if (selectedBill && selectedBill.length > 0 && selectedBill[0]?.customer) {
        handleViewBill(selectedBill[0].customer);
      }
    } else {
      toast.error(response.data.message || "Something went wrong");
    }
  } catch(e) {
    toast.error(e?.response?.data?.message || e?.message || "Error linking property");
  }
};

const handleFormSubmit = async (payload) => {

  payload['uid'] = auth.user.id
  try{
      const response = await axios.post(rootUrl('/addBill'), payload)
      if(response.data.status === 200){
          toast.success("Submitted successfully")
          setShowAddBillModal(false)
          fetchBills()
      }else{
          toast.error("Something went wrong")
      }

  }catch(e){
      toast.error(e?.message)
  }
};

const componentRef = useRef(null);

  const handleExportDemandNoticePDF = async () => {
    const content = componentRef.current;
    if (!content) return;
    try {
      const canvas = await html2canvas(content, {
        scale: 2,
        useCORS: true,
        allowTaint: false,
        backgroundColor: "#ffffff",
        logging: false,
      });
      const imgData = canvas.toDataURL("image/jpeg", 0.95);
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 10;
      const pdfWidth = pageWidth - 2 * margin;
      const pdfPageHeight = pageHeight - 2 * margin;
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;
      let yPosition = margin;
      for (let page = 0; ; page++) {
        if (page > 0) pdf.addPage();
        pdf.addImage(imgData, "JPEG", margin, yPosition, pdfWidth, imgHeight);
        const visibleBottom = (page + 1) * pdfPageHeight;
        if (visibleBottom >= imgHeight) break;
        yPosition -= pdfPageHeight;
      }
      const councilName = allData?.council?.[0]?.name?.replace(/\s+/g, "_") || "Council";
      pdf.save(`Demand_Notice_${councilName}_${new Date().toISOString().slice(0, 10)}.pdf`);
      toast.success("PDF exported successfully");
    } catch (err) {
      console.error("PDF export error:", err);
      toast.error("Failed to export PDF");
    }
  };



  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-blue-950 to-blue-800 rounded-2xl p-6 text-white shadow-lg">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="bg-white/20 rounded-xl p-3">
              <PiInvoice className="text-2xl" />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-bold">Bills Management</h1>
              <p className="text-blue-100 text-sm mt-1">Manage customer bills, view statements and record payments</p>
            </div>
          </div>
        </div>
      </div>

      {/* Top navigation tabs */}
      <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-2">
        <div className="inline-flex rounded-lg bg-gray-100 p-1">
          <button
            className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg transition-all ${
              activeTab === 'customers'
                ? 'bg-gradient-to-r from-blue-950 to-blue-800 text-white shadow-md scale-105'
                : 'text-gray-700 hover:bg-white'
            }`}
            onClick={() => setActiveTab('customers')}
          >
            <FaList />
            <span>Customers</span>
          </button>
          <button
            className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg transition-all ${
              activeTab === 'bills'
                ? 'bg-gradient-to-r from-blue-950 to-blue-800 text-white shadow-md scale-105'
                : 'text-gray-700 hover:bg-white'
            }`}
            onClick={() => setActiveTab('bills')}
          >
            <PiInvoice />
            <span>Bills</span>
          </button>
        </div>
      </div>

      {activeTab === 'customers' ? (
        <>
          {/* Action Button */}
          <div className="flex justify-end">
            <button
              onClick={handleAddBill}
              className="flex items-center gap-2 px-4 py-2.5 bg-gradient-to-r from-blue-950 to-blue-800 text-white rounded-lg hover:shadow-lg transition-all font-medium shadow-sm"
            >
              <FaPlus />
              <span>Add Bill</span>
            </button>
          </div>

          {/* Search + summary */}
          <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
            <div className="flex flex-col md:flex-row md:items-end gap-4">
              <div className="flex-1">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  <div className="flex items-center gap-2">
                    <FaSearch className="text-gray-500 text-sm" />
                    <span>Search Customers</span>
                  </div>
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FaSearch className="h-4 w-4 text-gray-400" />
                  </div>
                  <input
                    type="text"
                    placeholder="Search customers..."
                    value={searchQuery}
                    onChange={e => setSearchQuery(e.target.value)}
                    className="w-full pl-10 pr-10 py-2.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                  />
                  {searchQuery && (
                    <button
                      onClick={() => setSearchQuery('')}
                      className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors"
                    >
                      <FaTimes className="h-4 w-4" />
                    </button>
                  )}
                </div>
              </div>
              <div className="flex-shrink-0">
                <div className="bg-white px-4 py-2.5 rounded-lg border border-gray-300 text-sm text-gray-700 font-medium">
                  Total: {filteredData.length} customer{filteredData.length === 1 ? "" : "s"}
                </div>
              </div>
            </div>
          </div>

          {/* Data table wrapper */}
          <div className="bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden">
            <DataTable
              title=""
              columns={columns}
              data={filteredData}
              pagination
              highlightOnHover
              striped
              responsive
              customStyles={customStyles}
            />
          </div>

          <div className="bg-gray-50 rounded-lg p-4 border border-gray-200 text-right">
            <span className="text-sm font-medium text-gray-700">Total Outstanding: </span>
            <span className="text-lg font-bold text-blue-950">
              {formatToZMW(totalOutstanding)}
            </span>
          </div>

          {/* View Bill Modal */}
          {showBillModal && (
            <Modal title="View Bill" onClose={() => { setShowBillModal(false); setShowDemandNotice(false); setToggle(false); }}>
              {selectedBill ? (
                <>
                  {(() => {
                    const hasPropertyBills = selectedBill?.some(b => b.pid && Number(b.pid) !== 0);
                    return (
                  <div className="flex items-center justify-between mb-4 pb-4 border-b border-gray-200">
                    {toggle || showDemandNotice ? (
                      <button
                        onClick={() => { setToggle(false); setShowDemandNotice(false); }}
                        className="inline-flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-lg text-sm font-medium transition-colors"
                      >
                        <FaArrowAltCircleLeft />
                        <span>Back to statement</span>
                      </button>
                    ) : (
                      <div />
                    )}
                    <div className="flex gap-2">
                      {hasPropertyBills && !toggle && (
                        <button
                          onClick={() => setShowDemandNotice(!showDemandNotice)}
                          className={`inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                            showDemandNotice
                              ? 'bg-amber-600 text-white'
                              : 'bg-amber-100 hover:bg-amber-200 text-amber-800 border border-amber-300'
                          }`}
                          title="Demand Notice"
                        >
                          <FaFileLines />
                          <span>{showDemandNotice ? "Hide Demand Notice" : "Demand Notice"}</span>
                        </button>
                      )}
                      {showDemandNotice && (
                        <button
                          onClick={handleExportDemandNoticePDF}
                          className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg text-sm font-medium transition-all"
                        >
                          <FaFilePdf />
                          <span>Export PDF</span>
                        </button>
                      )}
                      <button
                        onClick={() => handlePrint(componentRef)}
                        className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-950 to-blue-800 text-white px-4 py-2 rounded-lg text-sm font-medium hover:shadow-lg transition-all"
                      >
                        <FaPrint />
                        <span>Print</span>
                      </button>
                    </div>
                  </div>
                    );
                  })()}

                  <div ref={componentRef} className="bg-white rounded-lg border border-gray-200 p-3 md:p-4">
                    {showDemandNotice ? (
                      <DemandNotice
                        statement={statement}
                        selectedBill={selectedBill}
                        property={property}
                        allData={allData}
                        formatDate={formatDate}
                        formatToZMW={formatToZMW}
                        formatDateDDMMYYYY={formatDateDDMMYYYY}
                      />
                    ) : toggle ? (
                      <PropertyRatesBill
                        items={items}
                        itemGroup={itemGroup}
                        allData={allData}
                        showActBill={showActBill}
                        isDebit={isDebit}
                        property={property}
                      />
                    ) : (
                      <AllRatesBill
                        statement={statement}
                        selectedBill={selectedBill}
                        allData={allData}
                        showActBill={showActBill}
                        property={property}
                      />
                    )}
                  </div>

                  <div className="mt-6 pt-4 border-t border-gray-200">
                    {toggle && (
                      <div className="flex gap-3 flex-wrap">
                        <button
                          className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-gradient-to-r from-blue-950 to-blue-800 text-white text-sm font-medium hover:shadow-lg transition-all"
                          onClick={() => setMakePayment(!makePayment)}
                        >
                          <FaPlus />
                          <span>{makePayment ? "Close Payment" : "Add Payment"}</span>
                        </button>
                        <button
                          className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-gradient-to-r from-green-600 to-green-700 text-white text-sm font-medium hover:shadow-lg transition-all"
                          onClick={() => {
                            if (!linkProperty) {
                              fetchProperties();
                            }
                            setLinkProperty(!linkProperty);
                          }}
                        >
                          <FaLink />
                          <span>{linkProperty ? "Close Link Property" : "Link Property"}</span>
                        </button>
                      </div>
                    )}

                    {makePayment && toggle && (
                      <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
                        <div className="flex items-center gap-2 mb-4">
                          <FaMoneyBill className="text-blue-600" />
                          <span className="font-bold text-lg text-gray-900">Make Payment</span>
                        </div>
                        <PayForm
                          data={itemGroup}
                          allData={allData}
                          onSubmitForm={onSubmitForm}
                        />
                      </div>
                    )}

                    {linkProperty && toggle && (
                      <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
                        <div className="flex items-center gap-2 mb-4">
                          <FaLink className="text-green-600" />
                          <span className="font-bold text-lg text-gray-900">Link Property to Bill</span>
                        </div>
                        <LinkPropertyForm
                          properties={availableProperties}
                          allData={allData}
                          onLinkProperty={handleLinkProperty}
                        />
                      </div>
                    )}
                  </div>
                </>
              ) : (
                <div className="flex items-center justify-center py-10">
                  <FaSpinner size={32} className="animate-spin text-blue-950" />
                </div>
              )}
            </Modal>
          )}

          {/* Add Bill Modal */}
          {showAddBillModal && (
            <Modal title="Add New Bill" onClose={() => setShowAddBillModal(false)}>
              <AddBillModal data={allData} onSubmit={handleFormSubmit} type={1} />
            </Modal>
          )}
        </>
      ) : (
        <ActualBills />
      )}
    </div>
  );
};



const DemandNotice = ({ statement, selectedBill, property, allData, formatDate, formatToZMW, formatDateDDMMYYYY }) => {
  if (!statement?.length || !selectedBill?.length) return null;

  // Get properties that have linked bills (pid != 0)
  const propertyIdsWithBills = [...new Set(
    statement.filter(item => item.type === 'Bill' && item.pid && Number(item.pid) !== 0).map(item => item.pid)
  )];

  // Calculate outstanding per property and get first invoice for account ref
  const propertyOutstandings = propertyIdsWithBills.map((pid) => {
    const prt = property.find((a) => a.id == pid);
    if (!prt) return null;

    let balance = parseFloat(prt.opening || 0);
    let firstInvoiceNo = '';

    statement.forEach((item) => {
      if (item.pid != pid) return;
      const amount = parseFloat(item.amount || 0);
      if (item.type === 'Bill') {
        balance += amount;
        if (!firstInvoiceNo && item.invoice_no) firstInvoiceNo = item.invoice_no;
      } else if (item.type === 'Receipt') {
        balance -= amount;
      }
    });

    return { prt, outstanding: balance, accountRef: firstInvoiceNo || `PROP-${prt.property_no}` };
  }).filter(Boolean).filter(({ outstanding }) => outstanding > 0);

  const customerName = selectedBill[0]?.name || '';
  const councilName = (allData?.council?.[0]?.name || 'Council').toUpperCase();

  if (propertyOutstandings.length === 0) {
    return (
      <div className="max-w-[210mm] mx-auto p-6">
        <p className="text-gray-600 text-center">No outstanding balances for property-linked bills.</p>
      </div>
    );
  }

  const noticeDate = new Date();
  const addressParts = [];
  if (propertyOutstandings[0]?.prt?.street) addressParts.push(propertyOutstandings[0].prt.street);
  if (propertyOutstandings[0]?.prt?.location) addressParts.push(propertyOutstandings[0].prt.location);
  const defaultAddress = addressParts.join(', ') || '________________________________';

  return (
    <div className="demand-notice-document max-w-[210mm] mx-auto bg-white text-black font-sans text-sm leading-relaxed" style={{ fontFamily: 'Times New Roman, serif' }}>
      {propertyOutstandings.map(({ prt, outstanding, accountRef }, idx) => {
        const addrParts = [];
        if (prt?.street) addrParts.push(prt.street);
        if (prt?.location) addrParts.push(prt.location);
        const fullAddress = addrParts.length ? addrParts.join(', ') : defaultAddress;

        return (
          <div
            key={prt.id}
            className="mb-10 p-8 border-b border-gray-300 last:border-0 print:mb-0 print:border-0"
            style={{ pageBreakInside: 'avoid', pageBreakAfter: idx < propertyOutstandings.length - 1 ? 'always' : 'auto' }}
          >
            {/* Legal notice header */}
            <p className="text-center font-bold text-xs uppercase tracking-wide text-red-700 mb-2">
              PLEASE NOTE THAT THIS DOCUMENT IS LEGALLY BINDING
            </p>

            <div className="flex justify-center mb-4">
              <img className="w-[100px] h-auto" src={rootUrl(`/${allData?.council[0]?.path}`)} alt="Council Logo" />
            </div>

            <h1 className="text-center font-bold text-lg uppercase mb-1">{councilName}</h1>
            <h2 className="text-center font-semibold text-base mb-6">
              NOTICE UNDER SECTION 24 OF THE RATING ACT NO. 21 OF 2018
            </h2>

            {/* Recipient details */}
            <div className="space-y-1 mb-6 text-sm">
              <p><span className="font-semibold">To:</span> <span className="underline">{customerName || '________________________________'}</span></p>
              <p><span className="font-semibold">Stand No:</span> <span className="underline">{prt.property_no || '_______________________________'}</span></p>
              <p><span className="font-semibold">Account No:</span> <span className="underline">{accountRef || '_____________________________'}</span></p>
              <p><span className="font-semibold">Address:</span> <span className="underline">{fullAddress || '________________________________'}</span></p>
              <p><span className="font-semibold">Date:</span> {formatDateDDMMYYYY(noticeDate)}</p>
            </div>

            <p className="mb-4">Dear Sir/Madam,</p>

            <p className="font-semibold mb-4">RE: ACCRUED RATES ON PROPERTY NO. {prt.property_no || '__________________'}</p>

            <p className="mb-4">
              Our records indicate that rates in respect of the above-mentioned property are currently in arrears in the sum of <strong>K{formatToZMW(outstanding)}</strong> as at {formatDateDDMMYYYY(noticeDate)}.
            </p>

            <p className="mb-4">
              In accordance with Section 24 of the Rating Act No. 21 of 2018, you are hereby reminded to settle the outstanding amount within thirty (30) days from the date of this notice.
            </p>

            <p className="mb-4">
              Please be advised that failure to make payment within the stipulated period will compel {councilName} to institute legal proceedings for recovery of the outstanding rates. This may include execution against your personal goods and chattels in order to recover the amount owed to the Council.
            </p>

            <p className="mb-4">
              Should you have any queries or require clarification, kindly visit the Revenue Section at the Civic Centre during working hours.
            </p>

            <p className="mb-8">Your cooperation in this matter will be greatly appreciated.</p>

            <p className="mb-2">Yours faithfully,</p>
            <div className="mb-2 h-12" />
            <p className="font-semibold">Council Secretary</p>
            <p className="font-semibold">{allData?.council?.[0]?.name || 'Council'}</p>

            {/* Receipt section */}
            <div className="mt-10 pt-6 border-t border-gray-400 space-y-2">
              <p><span className="font-semibold">Received by:</span> ___________________________</p>
              <p><span className="font-semibold">Date:</span> _________________________________</p>
              <p><span className="font-semibold">Phone No:</span> _____________________________</p>
              <p><span className="font-semibold">Signature:</span> _____________________________</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const PropertyRatesBill = ({items, itemGroup = [], allData, openingBalance, property, isDebit}) => {
  function getHalfOfYear(date) {
    const month = new Date(date).getMonth() + 1; // getMonth() is zero-based
    return month <= 6 ? "January to June" : "July to December";
  }

  const normalizedItems = itemGroup.length > 0 ? itemGroup : (items ? [items] : [])
  const primaryItem = normalizedItems[0] || items || {}

  const prt = property.find(a=>a.id == primaryItem.pid)


 let overall = 0
  return (
    <div className="max-w-3xl mx-auto p-6 border rounded-lg shadow-lg">
      <div className="flex justify-center">
      <img  className='w-[150px]' src={rootUrl(`/${allData?.council[0]?.path}`)} alt="Council Logo" />
      </div>
     
      <h2 className="text-xl font-bold text-center">{allData?.council[0]?.name}</h2>
      <h3 className="text-lg font-semibold text-center mt-2">{isDebit?prt?'PROPERTY RATES BILL':'INVOICE':'RECEIPT'}</h3>

    {
      isDebit && prt?
      <div className="grid grid-cols-2 gap-6 mt-6 p-4 border border-gray-300 bg-white">
      <div className="space-y-2">
      <p className="text-gray-700"><span className="font-semibold"> Owner:</span> <span>{items?.name}</span></p>

    <p className="text-gray-700"><span className="font-semibold">HSE No and Street:</span> <span>{prt?.street} {prt?.property_no}</span></p>
    <p className="text-gray-700"><span className="font-semibold">Town and Zone:</span> <span>{prt?.location}</span></p>
    <p className="text-gray-700"><span className="font-semibold">Description:</span> <span>{prt?.description}</span></p>
  </div>

   

    <div className="space-y-2">
      <p className="text-gray-700"><span className="font-semibold">Improve Value:</span> <span>{prt?.improvements}</span></p>
      <p className="text-gray-700"><span className="font-semibold">Land Value:</span> <span>{prt?.land_value}</span></p>

      <p className="text-gray-700"><span className="font-semibold">Rate Used:</span> <span>{parseFloat(prt?.annual_payable) / 2}</span></p>
      <p className="text-gray-700"><span className="font-semibold">Reference No.:</span> <span>{items?.invoice_no}</span></p>
      <p className="text-gray-700"><span className="font-semibold">Hectares .:</span> <span>{parseFloat(prt?.land_ext) == 0.0 ? '':prt?.land_ext}</span></p>
     
    </div>
</div>
:
<div className="grid grid-cols-2 gap-6 mt-6 p-4 border border-gray-300 bg-white">
      <p className="text-gray-700"><span className="font-semibold"> Customer:</span> <span>{isDebit?primaryItem?.name:allData.suppliers.find(a=>a.id == primaryItem.cust)?.name}</span></p>
      <p className="text-gray-700"><span className="font-semibold">{isDebit?'Invoice No:':'Receipt No:'} </span> <span>{isDebit?primaryItem?.invoice_no:primaryItem?.receipt_no}</span></p>
</div>
    }
{
  isDebit?

  <table className="w-full mt-4 border-collapse border border-gray-300">
  <thead>
    <tr className="bg-blue-950 text-white">
      <th className="border border-gray-300 p-2">Date</th>
      <th className="border border-gray-300 p-2">Chart of Account</th>
      <th className="border border-gray-300 p-2">Description</th>
      <th className="border border-gray-300 p-2">Balance B/F</th>
      <th className="border border-gray-300 p-2"> Amount </th>
      <th className="border border-gray-300 p-2">Closing Amount</th>
    </tr>
  </thead>
  <tbody>
  {(() => {
    let runningBalance = parseFloat(prt?.opening || 0)
    return normalizedItems.map((entry, idx) => {
      const amount = parseFloat(entry.amount || 0)
      const balanceBF = idx === 0 ? runningBalance : runningBalance
      runningBalance += amount
      const coaLabel = allData.budget?.find(a=>a.id === entry.coa_id)?.coa
      const coaName = allData.coa?.find(a=>a.account === coaLabel)?.name
      const actualDescription = entry?.description || entry?.desc || ""
      if (idx === normalizedItems.length - 1) {
        overall = runningBalance
      }
      return (
        <tr className="" key={`${entry.b_id || entry.id}-${idx}`}>
          <td className="border border-gray-300 p-2">{formatDate(entry.date.toString())}</td>
          <td className="border border-gray-300 p-2">{coaLabel} : {coaName}</td>
          <td className="border border-gray-300 p-2">{actualDescription}</td>
          <td className="border border-gray-300 p-2">{balanceBF}</td>
          <td className="border border-gray-300 p-2"> {amount} </td>
          <td className="border border-gray-300 p-2">{runningBalance}</td>
        </tr>
      )
    })
  })()}
  </tbody>
</table>

:

<table className="w-full mt-4 border-collapse border border-gray-300">
<thead>
  <tr className="bg-blue-950 text-white">
    <th className="border border-gray-300 p-2">Date</th>
    <th className="border border-gray-300 p-2">Description</th>
    <th className="border border-gray-300 p-2"> Amount </th>
  </tr>
</thead>
<tbody>
{normalizedItems.map((entry, idx) => (
  <tr className="" key={`${entry.id || entry.b_id}-${idx}`}>
      <td className="border border-gray-300 p-2">{formatDate(entry.date.toString())}</td>
      <td className="border border-gray-300 p-2">
      {entry.description}
      </td>
      <td className="border border-gray-300 p-2"> {entry.amount} </td>
    </tr>
))}
</tbody>
</table>
}
    

{
  isDebit?
  <div className="mt-4">
  <p><strong>Amount Due (ZMK):</strong>{overall || parseFloat(prt?.opening || 0)}</p>
</div>:
null
}
      <hr className="my-5" />

      <div className="grid grid-cols-2 gap-4">
        <div>
        <p><strong>Issued By:</strong> {isDebit?'__________________':allData.users.find(a=>a.u_id == items.issuer)?.firstname +' '+allData.users.find(a=>a.u_id == items.issuer)?.lastname} </p>
        <p><strong>Signature:</strong> __________________</p>
        </div>
        <div>
        <p><strong>Received By:</strong> _________________</p>
        <p><strong>Signature:</strong> ___________________</p>
        </div>
       
      </div>

{/* <hr className="my-5" /> */}
      {/* <div className="mt-4">
        <h3 className="text-lg font-semibold">Payment Details</h3>

        <div className="grid grid-cols-2 gap-4">
          <div>
          <p className="mt-2"><strong>Bank Name:</strong> {allData.bank[0]?.name.split("-")[1]}</p>
          <p><strong>Account Name:</strong> {allData.bank[0]?.name.split("-")[0]}</p>
          <p><strong>Account #:</strong> {allData.bank[0]?.account_no}</p>
          <p><strong>Branch:</strong> </p>
          </div>
          <div>
          <p className="mt-2"><strong>Bank Name:</strong> {allData.bank[1]?.name.split("-")[1]}</p>
          <p><strong>Account Name:</strong> {allData.bank[1]?.name.split("-")[0]}</p>
          <p><strong>Account #:</strong> {allData.bank[1]?.account_no}</p>
          <p><strong>Branch:</strong> </p>
          </div>

        </div>
        
        
      </div> */}
    </div>
  );
};

const AllRatesBill = ({statement, selectedBill, allData, property, showActBill}) => {
  function getHalfOfYear(date) {
    const month = new Date(date).getMonth() + 1; // getMonth() is zero-based
    return month <= 6 ? "January to June" : "July to December";
  }

 let overall = 0

 const open = sumOfArray(property.map((res)=>parseFloat(res.opening)))

  // Age analysis logic
  const today = new Date();
  const ageBuckets = [
    { label: '0-30 days', min: 0, max: 30 },
    { label: '31-60 days', min: 31, max: 60 },
    { label: '61-90 days', min: 61, max: 90 },
    { label: '91+ days', min: 91, max: Infinity }
  ];
  // Get unpaid bills only (type === 'Bill' and not offset by a receipt)
  const unpaidBills = statement.filter(item => item.type === 'Bill' && !statement.some(r => r.type === 'Receipt' && r.b_id === item.b_id && r.amount === item.amount));
  // Sum amounts in each age bucket
  const ageAnalysis = ageBuckets.map(bucket => {
    let sum = unpaidBills.reduce((acc, bill) => {
      const billDate = bill.date ? new Date(bill.date) : null;
      console.log(bill)
      console.log(statement)
      if (!billDate) return acc;
      const age = Math.floor((today - billDate) / (1000 * 60 * 60 * 24));
      if (age >= bucket.min && age <= bucket.max) {
        // Find matching receipts for this bill item
        const receipts = statement.filter(r => r.type === 'Receipt' && r.b_id === bill.b_id);
        const receiptsTotal = receipts.reduce((racc, r) => racc + parseFloat(r.amount), 0);
        const unpaidAmount = parseFloat(bill.amount) - receiptsTotal;
        return unpaidAmount > 0 ? acc + unpaidAmount : acc;
      }
      return acc;
    }, 0);
    // Add opening balance to 91+ days bucket
    if (bucket.label === '91+ days') {
      sum += open;
    }
    return { ...bucket, sum };
  });

  return (
    <div className="max-w-3xl mx-auto p-6 border rounded-lg shadow-lg">
      <div className="flex justify-center">
      <img  className='w-[150px]' src={rootUrl(`/${allData?.council[0]?.path}`)} alt="Council Logo" />
      </div>
     
      <h2 className="text-xl font-bold text-center">{allData?.council[0]?.name}</h2>
      <h3 className="text-lg font-semibold text-center mt-2">Customer Statment</h3>
      <h3 className="text-lg font-semibold text-center mt-2">{selectedBill[0]?.name}</h3>
      <table className="w-full mt-4 border-collapse border border-gray-300">
        <thead>
          <tr className="bg-blue-950 text-white">
            <th className="border border-gray-300 p-2">Date</th>
            <th className="border border-gray-300 p-2">Property</th>
            <th className="border border-gray-300 p-2">Period</th>
            <th className="border border-gray-300 p-2">Account No</th>
            <th className="border border-gray-300 p-2">Type</th>
            <th className="border border-gray-300 p-2">Ref No.</th>
            <th className="border border-gray-300 p-2"> Amount</th>
            <th className="border border-gray-300 p-2"> Balance</th>

          </tr>
        </thead>
        <tbody>
        <tr className="bg-white">
            <td className="border border-gray-300 p-2">2025-01-01</td>
            <td className="border border-gray-300 p-2"></td>
            <td className="border border-gray-300 p-2"></td>
            <td className="border border-gray-300 p-2"></td>
            <td className="border border-gray-300 p-2">Opening Balance</td>
            <td className="border border-gray-300 p-2"> {open}</td>
            <td className="border border-gray-300 p-2"> {open}</td>

          </tr>
        {statement.reduce(
    (acc, item, index) => {
   
      const isDebit = item.type === "Bill";
      const amount = parseFloat(item.amount);
      const pty = property.find(a=>a.id == item.pid)
      if (index === 0) {
        acc.cumulativeBalance += open; // Add opening balance only once
      }
  
      // Update cumulative balance
      const newBalance = isDebit
        ? acc.cumulativeBalance + amount
        : acc.cumulativeBalance - amount;
  
      // Push the current row with updated values
      acc.rows.push(
        <tr
          key={index}
          className={index % 2 === 0 ? "bg-gray-100" : "bg-white"}
          onClick={()=>showActBill(item, isDebit)}
        >
          <td className="px-4 py-2 border">
            {(item.date.toISOString().substring(0, 10))}
          </td>
         
          <td className="px-4 py-2 border">{pty?.property_no}  {pty?.description}</td>
          <td className="px-4 py-2 border">{getHalfOfYear(item.date)}</td>
          <td className="px-4 py-2 border">
          
            {
              isDebit?
              <>
                {allData.budget?.find(a=>a.id === item.coa_id)?.coa} : 
                {allData.coa?.find(a=>a.account === allData.budget?.find(a=>a.id === item.coa_id)?.coa)?.name}
              </>
              :
              <>
                {allData.budget?.find(a=>a.id === selectedBill?.find(a=>a.id === item.b_id)?.coa_id)?.coa} : 
                {allData.coa?.find(a=>a.account === allData.budget?.find(a=>a.id === selectedBill?.find(a=>a.id === item.b_id)?.coa_id)?.coa)?.name}
              </>
            }
            
          </td>
          <td className="px-4 py-2 border">
            {isDebit ? "Bill": "Receipt"}
          </td>
          <td className="px-4 py-2 border">
            {isDebit ? (item.invoice_no || '-') : (item.receipt_no || '-')}
          </td>
          {/* <td className="px-4 py-2 border">
            {isDebit ? formatToZMW(openingBalance) : ""}
          </td> */}
         
          <td className="px-4 py-2 border">
            {isDebit ? formatToZMW(amount) : -(amount)}
            
          </td>
          {/* <td className="px-4 py-2 border">
            {!isDebit ? formatToZMW(amount) : ""}
          </td> */}
          <td className="px-4 py-2 border">
            {formatToZMW(newBalance)}
          </td>
        </tr>
      );

      // Update cumulative balance for the next row
      acc.cumulativeBalance = newBalance;
      overall = newBalance
      return acc;
    },
    { rows: [], cumulativeBalance: 0 } // Initial state
        ).rows}
        </tbody>
      </table>

      <div className="mt-4">
        <p><strong>Amount Due (ZMK):</strong>{overall}</p>
      </div>
      {/* Age Analysis Table */}
      <div className="mt-6">
        <h4 className="font-semibold mb-2">Age Analysis (Unpaid Bills)</h4>
        <table className="w-full border border-gray-300">
          <thead>
            <tr className="bg-blue-950 text-white">
              {ageBuckets.map(bucket => (
                <th key={bucket.label} className="border p-2">{bucket.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {ageAnalysis.map(a => (
                <td key={a.label} className="border p-2 text-right">{a.sum}</td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>

      <hr className="my-5" />

      <div className="grid grid-cols-2 gap-4">
        <div>
        <p><strong>Issued By:</strong> __________________</p>
        <p><strong>Signature:</strong> __________________</p>
        </div>
        <div>
        <p><strong>Received By:</strong> _________________</p>
        <p><strong>Signature:</strong> ___________________</p>
        </div>
       
      </div>

{/* <hr className="my-5" /> */}
      {/* <div className="mt-4">
        <h3 className="text-lg font-semibold">Payment Details</h3>

        <div className="grid grid-cols-2 gap-4">
          <div>
          <p className="mt-2"><strong>Bank Name:</strong> {allData.bank[0]?.name.split("-")[1]}</p>
          <p><strong>Account Name:</strong> {allData.bank[0]?.name.split("-")[0]}</p>
          <p><strong>Account #:</strong> {allData.bank[0]?.account_no}</p>
          <p><strong>Branch:</strong> </p>
          </div>
          <div>
          <p className="mt-2"><strong>Bank Name:</strong> {allData.bank[1]?.name.split("-")[1]}</p>
          <p><strong>Account Name:</strong> {allData.bank[1]?.name.split("-")[0]}</p>
          <p><strong>Account #:</strong> {allData.bank[1]?.account_no}</p>
          <p><strong>Branch:</strong> </p>
          </div>

        </div>
        
        
      </div> */}
    </div>
  );
};

const PropertySearchableSelect = ({ label, value, onChange, options = [], required = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);

  // Find selected option
  useEffect(() => {
    const selected = options.find(opt => opt.value == value);
    setSelectedOption(selected);
  }, [value, options]);

  // Filter options based on search term
  const filteredOptions = options.filter(option =>
    option.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (option) => {
    setSelectedOption(option);
    onChange(option.value);
    setIsOpen(false);
    setSearchTerm('');
  };

  const handleToggle = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setSearchTerm('');
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      setIsOpen(false);
      setSearchTerm('');
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.property-select-wrapper')) {
        setIsOpen(false);
        setSearchTerm('');
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);

  return (
    <div className="relative property-select-wrapper">
      <label className="block">
        <div className="text-sm font-medium text-gray-700 mb-1.5">
          {label} {required && <span className="text-red-500">*</span>}
        </div>
        <div className="relative">
          <button
            type="button"
            onClick={handleToggle}
            onKeyDown={handleKeyDown}
            className="w-full rounded-lg border border-gray-300 px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 text-left flex items-center justify-between bg-white transition-colors hover:border-green-400"
          >
            <span className={selectedOption ? 'text-gray-900' : 'text-gray-500'}>
              {selectedOption ? selectedOption.label : `Select ${label.toLowerCase()}`}
            </span>
            <svg
              className={`w-4 h-4 transition-transform text-gray-500 ${isOpen ? 'rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          
          {isOpen && (
            <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-hidden">
              <div className="p-2 border-b border-gray-200">
                <div className="relative">
                  <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
                  <input
                    type="text"
                    placeholder="Search properties..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-9 pr-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                    autoFocus
                  />
                </div>
              </div>
              <div className="max-h-48 overflow-y-auto">
                {filteredOptions.length > 0 ? (
                  filteredOptions.map((option) => (
                    <button
                      key={option.value}
                      type="button"
                      onClick={() => handleSelect(option)}
                      className={`w-full text-left px-4 py-2.5 text-sm hover:bg-green-50 transition-colors ${
                        option.value === value ? 'bg-green-100 text-green-900 font-medium' : 'text-gray-900'
                      }`}
                    >
                      {option.label}
                    </button>
                  ))
                ) : (
                  <div className="px-4 py-3 text-sm text-gray-500 text-center">
                    No properties found
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </label>
    </div>
  );
};

const LinkPropertyForm = ({ properties, allData, onLinkProperty }) => {
  const [selectedProperty, setSelectedProperty] = useState('');

  // Prepare options for SearchableSelect
  const propertyOptions = properties.map((property) => {
    const owner = allData.suppliers?.find(a => a.id == property.uid)?.name || 'Unknown Owner';
    return {
      value: property.id,
      label: `${property.property_no} - ${owner} (${property.location || 'No location'})`
    };
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedProperty) {
      toast.error("Please select a property");
      return;
    }
    onLinkProperty(selectedProperty);
    setSelectedProperty('');
  };

  return (
    <form onSubmit={handleSubmit} className="max-w-2xl mx-auto space-y-4">
      <PropertySearchableSelect
        label="Select Property"
        value={selectedProperty}
        onChange={setSelectedProperty}
        options={propertyOptions}
        required
      />
      <button
        type="submit"
        className="w-full bg-gradient-to-r from-green-600 to-green-700 text-white py-2.5 px-4 rounded-lg hover:shadow-lg transition-all font-medium"
      >
        Link Property
      </button>
    </form>
  );
};

export default Bills;
